import React from "react"
import AppTaskView from "../app"
import Task from "../../../core/model2/task/task"
import taskView_checkTimeReportAccess from "./check-time-report-access"

export default function taskView_addTimeReport(task?: Task) {

    if (!taskView_checkTimeReportAccess()) {
        return
    }

    if (!task) {
        const app : AppTaskView = gd.getApp() as unknown as AppTaskView
        task = app.task
    }

    if (task.isTemplate) {
        const message = <div>This action is not available for template tasks.</div>
        gd.modals.other.notification(message)
        return
    }

    gd.modals.myTime.timeReportForTask(task)
}